var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DatePicker',{attrs:{"type":_vm.type,"transfer":_vm.transfer,"placeholder":_vm.placeholder,"placement":_vm.placement,"format":_vm.format,"options":_vm.options,"value":_vm.currValue},on:{"on-change":_vm.onChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb97e46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmyDatePicker.vue
// module id = null
// module chunks = 